<template>
  <div class="modal-overlay" v-show="showModal">
    <div class="modal-content">
      <div class="modal-header">提示</div>
      <div class="modal-body">
        <div v-if="html!==''" v-html="html"></div>
        <div v-if="text!==''">{{text}}</div>
      </div>
      <div class="modal-footer">
        <button v-if="showCancelButton" class="modal-btn cancel" @click="cancel">{{cancelButton}}</button>
        <button v-if="showConfirmButton" class="modal-btn confirm" @click="confirm">{{confirmButton}}</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Modal',
    props: {
      title: {
        type: String,
        default: '提示'
      },
      text: {
        type: String,
        default: ''
      },
      html: {
        type: String,
        default: ''
      },
      showConfirmButton: {
        type: Boolean,
        default: true
      },
      confirmButton: {
        type: String,
        default: '确定'
      },
      showCancelButton: {
        type: Boolean,
        default: true
      },
      cancelButton: {
        type: String,
        default: '取消'
      }
    },
    data() {
      return {
        showModal: false,
        promise: '',
        resolve: '',
        reject: ''
      }
    },
    methods: {
      close() {
        this.showModal = false
        this.$destroy()
        document.body.removeChild(this.$el)
      },
      show() {
        this.showModal = true
        this.promise = new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });
        return this.promise;
      },
      cancel() {
        this.close()
        this.reject('cancel')
      },
      confirm() {
        this.close()
        this.resolve('confirm')
      }
    }
  }
</script>

<style scoped>
  .modal-overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    text-align: center;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .modal-overlay:after {
    content: "";
    display: inline-block;
    height: 100%;
    width: 0;
    vertical-align: middle;
  }

  .modal-content {
    display: inline-block;
    width: 600px;
    height: auto;
    background-color: white;
    border-radius: 4px;
    vertical-align: middle;
    overflow: hidden;
    text-align: left;
  }

  .modal-header {
    background-color: #f2f2f2;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    padding: 15px;
    color: #000000;
    font-size: 16px;
  }

  .modal-body {
    padding: 15px;
  }

  .modal-body h4 {
    font-weight: 500;
    font-size: 18px;
    line-height: 1.2;
    margin: 10px 0px;
  }

  .modal-body p {
    line-height: 1.2;
    margin-bottom: 10px;
  }

  .modal-body p a {
    color: #42B983;
  }

  .modal-footer {
    text-align: right;
    padding: 15px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  .modal-btn {
    display: inline-block;
    padding: 6px 12px;
    margin-left: 15px;
    border-radius: 20px;
    cursor: pointer;
  }
  
  .modal-btn:hover {
    opacity: 0.7;
  }

  .modal-btn.cancel {
    border: solid 1px #42B983;
    background-color: white;
    color: #42B983;
  }

  .modal-btn.confirm {
    padding: 6px 20px;
    border: solid 1px #42B983;
    background-color: #42B983;
    color: white;
  }
</style>
